import React, { useState, useEffect, useRef } from 'react';
import '../../../../pages/admin/admin_assets/css/Surveys.css';
import '../../../../pages/admin/admin_assets/css/responsive.css';
// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import enter_Arrow from '../../../../pages/admin/admin_assets/img/presskey.svg';
import preview_img from '../../../../pages/admin/admin_assets/img/preview.svg';
import share_img from '../../../../pages/admin/admin_assets/img/share.svg';
import add_img from '../../../../pages/admin/admin_assets/img/plus.svg';
import default_logo from '../../../../pages/admin/admin_assets/img/default_logo.jpg';
import { SmileOutlined } from '@ant-design/icons';
import { Button, Form, notification } from 'antd';
import { Breadcrumb } from 'antd';

import { useLocation } from 'react-router-dom';
import EmployeeResult from './EmployeeResult';

const EmployeeForm = (props) => {

    const [currentStep, setCurrentStep] = useState(0);
    const [showError, setShowError] = useState('');
    const [showStart, setShowStart] = useState(true);
    const [successMsg, setSuccessMsg] = useState(false);

    const [showOverlay, setOverlay] = useState(false)
    const [closeOverlay, setCloseOverlay] = useState()

  const [formData, setFormData] = useState({
     
        brandAlignment: [],
        ideaContribution: [],
        brandImprovement: [],
        jobSatisfaction: [],
        jobSupport: [],
        roleUnderstanding: [],
        trainingOpportunities: [],  // Initialize as empty array
        feedbackFrequency: [],       // Initialize as empty array
        recognition: [],   // Initialize as empty array
        workplaceImprovement: [], 
        communicationEffectiveness: [],
        policyRevision: [],
        careerGoals:[]
      
  });

  const questions = [
    {
        id: 1,
        questionText: "How aligned do you feel with our brand’s mission and values?",
        answerKey: 'brandAlignment',
        options: ['A Strongly Aligned', 'B Somewhat Aligned', 'C Neutral', 'D Not Aligned'],
        inputType: 'button'
    },
    {
        id: 2,
        questionText: "Do you feel empowered to contribute ideas to the brand?",
        answerKey: 'ideaContribution',
        options: ['A Always', 'B Often', 'C Rarely', 'D Never'],
        inputType: 'button'
    },
    {
        id: 3,
        questionText: "What suggestions do you have for improving our brand?",
        answerKey: 'brandImprovement',
        options: ['A Better Training', 'B Increased Transparency', 'C Improved Communication', 'D More Resources'],
        inputType: 'button'
    },
    {
        id: 4,
        questionText: "How would you rate your overall job satisfaction?",
        answerKey: 'jobSatisfaction',
        options: ['A Very Satisfied', 'B Satisfied', 'C Neutral', 'D Dissatisfied'],
        inputType: 'button'
    },
    {
        id: 5,
        questionText: "Do you receive adequate support and resources to perform your job effectively?",
        answerKey: 'jobSupport',
        options: ['A Always', 'B Most of the Time', 'C Occasionally', 'D Rarely'],
        inputType: 'button'
    },
    {
        id: 6,
        questionText: "How well do you understand your role in contributing to our brand’s success?",
        answerKey: 'roleUnderstanding',
        options: ['A Very Well', 'B Moderately Well', 'C Somewhat Well', 'D Not at All'],
        inputType: 'button'
    },
    {
        id: 7,
        questionText: "What additional training or development opportunities would you like to see?",
        answerKey: 'trainingOpportunities',
        options: ['A Leadership', 'B Technology', 'C Customer Service', 'D Cross-functional Skills'],
        inputType: 'button'
    },
    {
        id: 8,
        questionText: "How frequently do you receive feedback on your performance?",
        answerKey: 'feedbackFrequency',
        options: ['A Weekly', 'B Monthly', 'C Quarterly', 'D Rarely'],
        inputType: 'button'
    },
    {
        id: 9,
        questionText: "Do you feel recognized for your contributions to the brand?",
        answerKey: 'recognition',
        options: ['A Always', 'B Often', 'C Rarely', 'D Never'],
        inputType: 'button'
    },
    {
        id: 10,
        questionText: "What do you feel could improve in the workplace environment?",
        answerKey: 'workplaceImprovement',
        options: ['A Better Tools', 'B More Recognition', 'C Improved Communication', 'D Flexible Work Options'],
        inputType: 'button'
    },
    {
        id: 11,
        questionText: "How effective do you find our internal communication?",
        answerKey: 'communicationEffectiveness',
        options: ['A Very Effective', 'B Somewhat Effective', 'C Neutral', 'D Ineffective'],
        inputType: 'button'
    },
    {
        id: 12,
        questionText: "Are there any policies you feel should be revised or introduced?",
        answerKey: 'policyRevision',
        options: ['A Remote Work', 'B Work-life Balance', 'C Diversity Policies', 'D Leave Policies'],
        inputType: 'button'
    },
    {
        id: 13,
        questionText: "What are your long-term career goals, and how can the company support you in achieving them?",
        answerKey: 'careerGoals',
        options: ['A Promotion', 'B Skill Enhancement', 'C Mentorship', 'D New Roles'],
        inputType: 'button'
    }
    
      
  ];
     
  useEffect(() => {
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            if (showStart) {
                setShowStart(false);
            } else {
                nextStep(formData[questions[currentStep].answerKey]);
            }
        }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
}, [showStart, currentStep, formData, questions]); 


const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
    if (showError && value.trim() !== "") {
        setShowError('');
    }
};

const handleOptionClick = (answerKey, option) => {
    setFormData(prevState => ({
        ...prevState,
        [answerKey]: prevState[answerKey]
            ? prevState[answerKey].includes(option)
                ? prevState[answerKey].filter(item => item !== option)
                : [...prevState[answerKey], option]
            : [option] 
    }));
};

const nextStep = (currentInputValue) => {
    if ((typeof currentInputValue === 'string' && currentInputValue.trim() === "") ||
        (Array.isArray(currentInputValue) && currentInputValue.length === 0)) {
        setShowError('Required Field');
    } else {
        setShowError('');
        if (currentStep < questions.length - 1) {
            setCurrentStep(currentStep + 1);
        } else {
            handleSubmit();
        }
    };
}

const handleSubmit = () => {
    console.log(formData);
    setSuccessMsg('Form submitted. Check the console for data.');
};

// show copy link 
const [showCopyLink, setShowCopyLink] = useState(false)

const copyLink = ()=>{
    setShowCopyLink(true)
}



    // file file and drag 

    const [selectedImage, setSelectedImage] = useState(false);

    const getFile = ((event)=>{
        console.log(event);
            setSelectedImage(URL.createObjectURL(event.target.files[0]))
    });

    const handleDragOver = (event) => {
        event.preventDefault(); // Prevent default behavior (prevent file from being opened)
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0]; // Access files from the dataTransfer object
        if (file) {
            setSelectedImage(URL.createObjectURL(file));
        }
    };
    
    // file upload modal
    const [modalShow, setModalShow] = React.useState(false);

    function MyVerticallyCenteredModal(props) {
        return (
          <Modal
            {...props}
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton className='border-0'>
         
            </Modal.Header>
            <Modal.Body>
            <div className='position-relative'>
                    <input 
                        type="file" 
                        onChange={getFile} 
                        onDragOver={handleDragOver} 
                        onDrop={handleDrop} 
                        className='upload_logo_modal'
                        style={{ width: '100%'}} // Style as needed
                    />
                    <div className='upload_txt'>
                        <p className='mb-0'>Upload or drop an image right here</p>
                        <p className="file-types mb-0">JPG, PNG, or GIF. Up to 4MB.</p>
                        
                    </div>
                    {selectedImage && (
                        <div className='preview_img'>
                            <img src={selectedImage} alt="Selected" style={{ width: '100%', marginTop: '10px' }} />
                        </div>
                    )}

                    <div className='update text-center'>
                        <button onClick={updateHandle}>Update</button>
                    </div>
                </div>
            </Modal.Body>
          </Modal>
        );
      }

                      const [surveyTab, setSurveyTab] = useState(true)
                     const [resultTab, setResultTab] = useState(false)
                     
                     const [activeTab, setActiveTab] = useState('create')
                     const createHandle = ()=>{
                        setSurveyTab(true)
                        setResultTab(false)
                        setActiveTab('create')
                     }
            
                     const resultHandle = ()=>{
                       setResultTab(true)
                       setSurveyTab(false)
                       setActiveTab('result')
            
                   }
   
                //      const createHandle = ()=>{
                //         setSurveyTab(true)
                //         setResultTab(false)
                //         setActiveTab('create')
                //      }
   
                //      const resultHandle = ()=>{
                //        setResultTab(true)
                //        setSurveyTab(false)
                //        setActiveTab('result')
   
                //    }
                   const handleTabChange = (tab) => {
                       setActiveTab(tab);  // Set the active tab state
                   };
   
    //   hide copy link when preview icon clicked
    const [showPreview, setShowPreview] = useState()

    const hideCopyLink = ()=>{
        setShowPreview(false)
    }

          // adding overlay to the page
          const addBg = ()=>{
            setOverlay(true)
            setShowCopyLink(false)
            setFullForm('full_form')

        }

        const closePopOverlay = () =>{
            setOverlay(false)
            setFullForm(false)
        }

        // add new class for form
        const [fullForm, setFullForm] = useState()

        // Toast message to link copied
        const [api, contextHolder] = notification.useNotification();
        
        const openNotification = () => {
            api.open({
                message: 'Your form link has been copied',
            //   description:
            //     'Your form link has been copied',
              icon: (
                <SmileOutlined
                  style={{
                    color: '#108ee9',
                  }}
                />
              ),
            });
          };

        // copy link clipboard text

        const [copyFormLink, setCopyFormLink] = useState('https://form.typeform.com/to/orl4Qfv7')

        const clickText = async ()=>
        {
                    try{
                            await window.navigator.clipboard.writeText(copyFormLink)
                            openNotification()
                    }

                    catch(error){
                        console.error('Unable to copy the clipboard', error)
                    }
        }

        const [successMessage, setSuccessMessage] = useState(false)

        const updateHandle=()=>{
            setSuccessMessage(true)
        }

        const [customerForm,setCustomerForm] = useState(false)
        const [employeeForm,setEmployeeForm] = useState(false)
        const [partnerForm,setPartnerForm] = useState(false)
        const [investorForm,setInvestorForm] = useState(false)

        let location = useLocation();

        useEffect(()=>{

            if(location.pathname==="/admin/customer-form"){
                    // console.log("Yes it is customer detail");
                    // setCustomerForm(<CustomerForm/>)
                    setCustomerForm(true)

            }
            else if(location.pathname==="/admin/employee-form"){
                // console.log("Yes it is employee detail");
                // setEmployeeForm(<EmployeeForm/>)
                setEmployeeForm(true)
                setCustomerForm(false)

            }
            else if(location.pathname==="/admin/partner-form"){
                // console.log("Yes it is partner detail");
                // setPartnerForm(<PartnerForm/>)
                setPartnerForm(true)

            }
            else if(location.pathname==="/admin/investor-form"){
                // console.log("Yes it is investor detail");
                // setInvestorForm(<InvestorForm/>)
                setInvestorForm(true)
                setCustomerForm(false)

            }
            
        },[])

return (
<div className='container-fluid'>

{ <Breadcrumb
            items={[
            {
                title: 'Surveys ',
                href: '#'
            },
            
            {
                title: 'Employee',
            },
            ]}
        />}

        <div className='tabs_border survey_tabs'>
                <button onClick={createHandle} className={activeTab==='create' ? 'tab_active' :''}>
                    <p>Create</p>
                 </button>
                <button onClick={resultHandle} className={activeTab==='result' ? 'tab_active' :''}>
                    <p>Result</p>
                </button>
        </div>

     {contextHolder}


            {
                surveyTab ? (
<div className='form'>
    {
            showOverlay &&
                    <div className='overlay'>
                        <div className='' onClick={closePopOverlay}>
                            <p >
                            <img src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path fill='%23ffffff' d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z'/></svg>" alt="close"  style={{width:"19px"}}/>
                            </p>
                            </div>
                    </div>
    }
    {
        showCopyLink ? ( 
        <div className='copy_link_wrapper'>
            <div className='copy_link'>
                    <button onClick={clickText}><i class="fa fa-solid fa-link"></i> Copy</button>
                    <input type="text" value={copyFormLink}  onChange={(e)=>setCopyFormLink(e.target.value)}
                    />
            </div>    
        </div>

        ) : ("")
    }
    <div className={`form_wrapper ${fullForm ? "form_style" : ""}`}>
        <div className='row'>
            {
                selectedImage ? (
                <div className='log_upload'>
                    <img src={selectedImage} alt="" className='d_logo' />
                </div>
                ):
                (
                   
                 <div className='log_upload'> 
                 <img src={default_logo} alt="" className='d_logo' />
                 </div>
                ) 
                
            }
            
            <div className='parent'>
              
            <div className="form_sec">
            {
             showOverlay &&
                <div className='form_style_overlay'>
                    <div className='text-center' onClick={closePopOverlay}>
                        <p > <i class="fa-solid fa-xmark text-black"></i></p>
                        </div>
                </div>
          }

                {showStart ? 
                (
                    <div className='start'>
                        <h3>We're Here to Help! [EmployeeForm]</h3>
                        <p>Have questions or need assistance? Get in touch with us today.</p>
                        <div className='start_btn'>
                            <button onClick={() => setShowStart(false)}>Start</button>
                            <p>Press Enter <img src={enter_Arrow} alt="Enter Arrow" /></p>
                        </div>
                    </div>
                ) 
                : successMsg ?
                (
                    <div className='success-message'>
                        <h4>
                        🎉 Thank You for Prebooking!
                        </h4>
                <p>Our team will reach out to you shortly with further details. For questions, reach out at <a href='mailto:support@brewyourbrand.in'>support@brewyourbrand.in</a>  or call <a href="tel:+918150002200">+91 8150 00 22 00</a></p>
                    </div>
                )
                :
                ((

                    <div className='question_form'>
                        <form onSubmit={handleSubmit}>
                            {questions.map((question, index) => (
                                currentStep === index && (
                                    <div key={question.id}>
                                        <label>{question.id}. {question.questionText}</label>
                                        {question.inputType === 'button' ? 
                                            question.options.map(option => (
                                                <div className='check_form'>
                                                <div key={option}
                                                     className={`button-option ${formData[question.answerKey].includes(option) ? 'active' : ''}`}
                                                     onClick={() => handleOptionClick(question.answerKey, option)}>
                                                    {/* <span className="button-label">{option.charAt(0)}</span> */}
                                                     {option.slice(1)}
                                                </div>
                                                </div>
                                            )) : (
                                                <div className='text_form'>
                                                <input
                                                    type={question.inputType}
                                                    value={formData[question.answerKey]}
                                                    onChange={handleInputChange}
                                                    name={question.answerKey}
                                                />
                                                </div>
                                            )}
                                        <div className='next_prev'>
                                            {index > 0 && (
                                                <button type="button" onClick={() => setCurrentStep(currentStep - 1)}>Previous</button>
                                            )}
                                            {index < questions.length - 1 ? (
                                                <>
                                                <button type="button" onClick={() => nextStep(formData[questions[currentStep].answerKey])}>Next</button>
                                                </>
                                            ) : (
                                                <button type="submit">Submit</button>
                                            )}
                                        </div>
                                        {showError && <p className="error">{showError}</p>}
                                    </div>
                                )
                            ))}
                        </form>
                    </div>
                )
                )
                }
            </div>
            <div className='edit_prev'>
                <div className='right_wrapper'>
                        <div className='previous' onClick={addBg}>
                            <p>Preview</p>
                             <img src={preview_img} alt="" />
                        </div>
                        <hr />
                        <div className='share' onClick={copyLink}>
                            <p>Share</p>
                            <img src={share_img} alt="" />

                        </div>
                </div>

                <div className='edit_wrapper'>
                    <div className='edit_sec'>
                        <h5 className='mb-0'>Edit Preferences</h5>
                     </div>

                    <div className='brand_wrapper' onClick={() => setModalShow(true)}>
                        <p>Brand Logo</p>
                        <img src={add_img} alt="" />
                    </div>
                    {
                        successMessage && 
                        <div className="upload_msg">
                        <p>updated successfully</p>
                            </div>
                    }
                         
                </div>
            </div>
            </div>
        </div>
    </div>
    </div>
                ) :

                (
                    <div className=''>
                        <EmployeeResult/>
                    </div> 
                )
            }

    

         
        <MyVerticallyCenteredModal
    show={modalShow}
    onHide={() => setModalShow(false)}
  />

</div>
)
}

export default EmployeeForm